import { Maybe, MetadataAggregateBucketKey } from 'generated/graphql';

export function getMetadataId(metadata: Maybe<MetadataAggregateBucketKey>) {
  if (metadata?.__typename === 'MetadataAggregateBucketKey') {
    return metadata.keyValues
      .map((keyValue) => {
        return keyValue.value;
      })
      .join(', ');
  }

  return '';
}
